import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FormSelect from '../../../../../../antd/form/FormSelect/FormSelect';
import { required } from '../../../../../../antd/form/FormValidation.js';
import FormButton from '../../../../../../antd/form/FormButton/FormButton';
import FormButtonsContainer from '../../../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import { CollapseBlock, Spinner } from '../../../../../../common/index';
import FormTextField from '../../../../../../antd/form/FormTextField/FormTextField';
import { useDataGridTextFilter } from '../../../../../../common/DataGrid/filters/useDataGridTextFilter';
import DataGrid from '../../../../../../common/DataGrid/DataGrid';
import { dataGridTextSorter } from '../../../../../../common/DataGrid/sorters/DataGridSorters';
import { Button, Col, Form, Grid, Row } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

const { Item, List } = Form;

const ErasmusSubjectsEditForm = ({
  onSubmit,
  initials,
  isPreview,
  isCreate,
  universities,
  localSubjects,
  onLocalSubjectDelete,
  filteredSubjects,
}) => {
  const { t } = useTranslation();
  const screens = Grid.useBreakpoint();

  const filteredUniversitiesOptions = useMemo(
    () =>
      universities.map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      }),
    [localSubjects],
  );

  const filteredSubjectsOptions = useMemo(
    () =>
      localSubjects.map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      }),
    [localSubjects],
  );

  const nameOfPermissionFilterProps = useDataGridTextFilter('name');

  const columnsLocalSubjects = useMemo(
    () => [
      {
        title: t('Uznané za predmety'),
        dataIndex: 'name',
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        ...nameOfPermissionFilterProps,
      },
    ],
    [t, nameOfPermissionFilterProps],
  );

  if (!initials && isLoading) {
    return <Spinner />;
  }

  return (
    <Form onFinish={onSubmit} initialValues={initials}>
      <CollapseBlock title={t('Údaje predmetu')}>
        <FormSelect
          label={t('Zahraničná univerzita')}
          name={'university_id'}
          placeholder={t('Vyhľadať zahraničnú univerzitu')}
          options={filteredUniversitiesOptions}
        />
        {isCreate ? (
          <List name="subjects">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }) =>
                  screens.md ? (
                    <Row key={name} gutter={[16, 16]}>
                      <Col span={10}>
                        <FormTextField
                          label={t('Názov')}
                          name={[name, 'name']}
                          rules={[required(t)]}
                        />
                      </Col>
                      <Col span={10}>
                        <FormSelect
                          label={t('FRI predmety')}
                          name={[name, 'choosedLocalSubjectsId']}
                          placeholder={t('Vyhľadať predmet na FRI')}
                          options={filteredSubjectsOptions}
                          mode={'multiple'}
                        />
                      </Col>
                      <Col span={4} style={{ display: 'flex', marginBottom: 35 }}>
                        <MinusCircleOutlined
                          title={t('Odstrániť predmet')}
                          onClick={() => remove(name)}
                        />
                      </Col>
                    </Row>
                  ) : (
                    <Row key={name} gutter={8} align="middle" wrap={false}>
                      <Col flex="auto">
                        <div style={{ marginBottom: -12 }}>
                          <FormTextField
                            label={t('Názov')}
                            name={[name, 'name']}
                            rules={[required(t)]}
                          />
                        </div>
                        <FormSelect
                          label={t('FRI predmety')}
                          name={[name, 'choosedLocalSubjectsId']}
                          placeholder={t('Vyhľadať predmet na FRI')}
                          options={filteredSubjectsOptions}
                          mode={'multiple'}
                        />
                      </Col>
                      <Col
                        flex="24px"
                        style={{ alignSelf: 'center', textAlign: 'center' }}
                      >
                        <MinusCircleOutlined
                          title={t('Odstrániť predmet')}
                          onClick={() => remove(name)}
                        />
                      </Col>
                    </Row>
                  ),
                )}
                <Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    {t('Pridať predmet')}
                  </Button>
                </Item>
              </>
            )}
          </List>
        ) : (
          <Row gutter={[16, 16]}>
            <Col xs={24} md={12}>
              <FormTextField
                label={t('Názov')}
                name={'name'}
                rules={[required(t)]}
              />
            </Col>
            <Col xs={24} md={12}>
              <FormSelect
                label={t('FRI predmety')}
                name={'choosedLocalSubjectsId'}
                placeholder={t('Vyhľadať predmet na FRI')}
                options={filteredSubjectsOptions}
                mode={'multiple'}
              />
            </Col>
          </Row>
        )}
        <DataGrid
          rowKey={(data) => data.id}
          columns={columnsLocalSubjects}
          dataSource={filteredSubjects || []}
          permissionsBasic={'roles'}
          onDelete={onLocalSubjectDelete}
          openDeleteModal={false}
          style={{ marginBottom: '16px' }}
        />
        {isPreview ? null : (
          <FormButtonsContainer>
            <FormButton submitOnClick={true} submitKey={'erasmusApplications'}>
              {t('Uložiť')}
            </FormButton>
          </FormButtonsContainer>
        )}
      </CollapseBlock>
    </Form>
  );
};

export default ErasmusSubjectsEditForm;
